import { Contract, types } from '@jutro/contract';
export default Contract.specify({
  getAvailableLocales: types.func,
  getAvailableLanguages: types.func,
  getPreferredLocale: types.func,
  getPreferredLanguage: types.func,
  getDefaultCountryCode: types.func,
  getDefaultPhoneCountry: types.func
});